import '../common/common.js';
import { MethodFromHashHelper } from './MethodFromHashHelper.js';
import { OrderGlobals } from './OrderGlobals.js';
import { Messages } from './Messages.js';
import { ServicesPresenterBuilder, ServicesServerBoundaryBuilder, ServicesViewBuilder } from './Services.js';
import { CloseParent } from './CloseParent.js';
import { IosScrollPreservation } from './IosScrollPreservation.js';

MethodFromHashHelper.initialize();
OrderGlobals.initialize();
Messages.initialize();
ServicesServerBoundaryBuilder.initialize();
ServicesViewBuilder.initialize();
ServicesPresenterBuilder.initialize();
CloseParent.initialize();
IosScrollPreservation.initialize();

window.o_global.eventQBus.emitModuleLoaded('ft1.order-core.common-private');
